import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("C:/git/niem/niem-toolbox/layouts/custom.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("C:/git/niem/niem-toolbox/layouts/default.vue").then(m => m.default || m))
}